export default class MetaObjectState {
	static ACTIVE = 'ACTIVE';
	static STALE = 'STALE';
	static DELETED = 'DELETED';
	static INVALID = 'INVALID';
}
